module.exports = __webpack_public_path__ + "static/media/MTL_SL_KETONE4.a8d9dcdd.png";